import { render, staticRenderFns } from "./ali-pay.vue?vue&type=template&id=13f550ae&scoped=true"
import script from "./ali-pay.vue?vue&type=script&lang=js"
export * from "./ali-pay.vue?vue&type=script&lang=js"
import style0 from "./ali-pay.vue?vue&type=style&index=0&id=13f550ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f550ae",
  null
  
)

export default component.exports